module.exports = __webpack_public_path__ + "files/8796815fc5d51428774cc70e22bbf78b.png";